function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/moveoperation
 */
import Operation from './operation';
import Position from '../position';
import Range from '../range';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import compareArrays from '@ckeditor/ckeditor5-utils/src/comparearrays';
import { _move } from './utils';
/**
 * Operation to move a range of {@link module:engine/model/item~Item model items}
 * to given {@link module:engine/model/position~Position target position}.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var MoveOperation = /*#__PURE__*/function (_Operation) {
  _inherits(MoveOperation, _Operation);

  var _super = _createSuper(MoveOperation);

  /**
   * Creates a move operation.
   *
   * @param {module:engine/model/position~Position} sourcePosition
   * Position before the first {@link module:engine/model/item~Item model item} to move.
   * @param {Number} howMany Offset size of moved range. Moved range will start from `sourcePosition` and end at
   * `sourcePosition` with offset shifted by `howMany`.
   * @param {module:engine/model/position~Position} targetPosition Position at which moved nodes will be inserted.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function MoveOperation(sourcePosition, howMany, targetPosition, baseVersion) {
    var _this;

    _classCallCheck(this, MoveOperation);

    _this = _super.call(this, baseVersion);
    /**
     * Position before the first {@link module:engine/model/item~Item model item} to move.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/moveoperation~MoveOperation#sourcePosition
     */

    _this.sourcePosition = sourcePosition.clone(); // `'toNext'` because `sourcePosition` is a bit like a start of the moved range.

    _this.sourcePosition.stickiness = 'toNext';
    /**
     * Offset size of moved range.
     *
     * @member {Number} module:engine/model/operation/moveoperation~MoveOperation#howMany
     */

    _this.howMany = howMany;
    /**
     * Position at which moved nodes will be inserted.
     *
     * @member {module:engine/model/position~Position} module:engine/model/operation/moveoperation~MoveOperation#targetPosition
     */

    _this.targetPosition = targetPosition.clone();
    _this.targetPosition.stickiness = 'toNone';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MoveOperation, [{
    key: "type",
    get: function get() {
      if (this.targetPosition.root.rootName == '$graveyard') {
        return 'remove';
      } else if (this.sourcePosition.root.rootName == '$graveyard') {
        return 'reinsert';
      }

      return 'move';
    }
    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/moveoperation~MoveOperation} Clone of this operation.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
    }
    /**
     * Returns the start position of the moved range after it got moved. This may be different than
     * {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition} in some cases, i.e. when a range is moved
     * inside the same parent but {@link module:engine/model/operation/moveoperation~MoveOperation#targetPosition targetPosition}
     * is after {@link module:engine/model/operation/moveoperation~MoveOperation#sourcePosition sourcePosition}.
     *
     *		 vv              vv
     *		abcdefg ===> adefbcg
     *		     ^          ^
     *		     targetPos	movedRangeStart
     *		     offset 6	offset 4
     *
     * @returns {module:engine/model/position~Position}
     */

  }, {
    key: "getMovedRangeStart",
    value: function getMovedRangeStart() {
      return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/moveoperation~MoveOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      var newTargetPosition = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

      return new this.constructor(this.getMovedRangeStart(), this.howMany, newTargetPosition, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      var sourceElement = this.sourcePosition.parent;
      var targetElement = this.targetPosition.parent;
      var sourceOffset = this.sourcePosition.offset;
      var targetOffset = this.targetPosition.offset; // Validate whether move operation has correct parameters.
      // Validation is pretty complex but move operation is one of the core ways to manipulate the document state.
      // We expect that many errors might be connected with one of scenarios described below.

      if (sourceOffset + this.howMany > sourceElement.maxOffset) {
        /**
         * The nodes which should be moved do not exist.
         *
         * @error move-operation-nodes-do-not-exist
         */
        throw new CKEditorError('move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.', this);
      } else if (sourceElement === targetElement && sourceOffset < targetOffset && targetOffset < sourceOffset + this.howMany) {
        /**
         * Trying to move a range of nodes into the middle of that range.
         *
         * @error move-operation-range-into-itself
         */
        throw new CKEditorError('move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.', this);
      } else if (this.sourcePosition.root == this.targetPosition.root) {
        if (compareArrays(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == 'prefix') {
          var i = this.sourcePosition.path.length - 1;

          if (this.targetPosition.path[i] >= sourceOffset && this.targetPosition.path[i] < sourceOffset + this.howMany) {
            /**
             * Trying to move a range of nodes into one of nodes from that range.
             *
             * @error move-operation-node-into-itself
             */
            throw new CKEditorError('move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.', this);
          }
        }
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      _move(Range._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(MoveOperation.prototype), "toJSON", this).call(this);

      json.sourcePosition = this.sourcePosition.toJSON();
      json.targetPosition = this.targetPosition.toJSON();
      return json;
    }
    /**
     * @inheritDoc
     */

  }], [{
    key: "className",
    get: function get() {
      return 'MoveOperation';
    }
    /**
     * Creates `MoveOperation` object from deserilized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/moveoperation~MoveOperation}
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json, document) {
      var sourcePosition = Position.fromJSON(json.sourcePosition, document);
      var targetPosition = Position.fromJSON(json.targetPosition, document);
      return new this(sourcePosition, json.howMany, targetPosition, json.baseVersion);
    }
  }]);

  return MoveOperation;
}(Operation);

export { MoveOperation as default };